(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shipping-date"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-date-bar')) {
    class ShippingDateBar extends HTMLElement {
      connectedCallback() {
        const target = this.querySelector('[data-shipping-date]');
        if (!target) return;

        const date = new Date();
        let daysLeft = Math.max(0, parseInt(this.dataset.days, 10) || 0);
        const skipWeekends = this.dataset.skipWeekends === 'true';

        if (skipWeekends) {
          while (daysLeft > 0) {
            date.setDate(date.getDate() + 1);
            const day = date.getDay();
            if (day !== 0 && day !== 6) daysLeft -= 1;
          }
        } else {
          date.setDate(date.getDate() + daysLeft);
        }

        const locale = this.dataset.locale || undefined;
        const format = this.dataset.format;

        try {
          if (format === 'long') {
            target.textContent = new Intl.DateTimeFormat(locale, {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
            }).format(date);
          } else if (format === 'day_month') {
            target.textContent = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' }).format(date);
          } else {
            // "Wed Jan 7"
            const parts = new Intl.DateTimeFormat(locale, {
              weekday: 'short',
              month: 'short',
              day: 'numeric',
            }).formatToParts(date);
            const get = (type) => parts.find((p) => p.type === type)?.value || '';
            target.textContent = `${get('weekday')} ${get('month')} ${get('day')}`.replace(/\./g, '');
          }
        } catch (_) {
          target.textContent = date.toDateString().slice(0, 10);
        }
      }
    }

    customElements.define('shipping-date-bar', ShippingDateBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["upsell-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('upsell-product-block')) {
    class UpsellProductBlock extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-upsell-form]');
        this.select = this.querySelector('[data-upsell-select]');
        this.button = this.querySelector('[data-upsell-button]');
        this.priceEl = this.querySelector('[data-upsell-price]');
        this.compareEl = this.querySelector('[data-upsell-compare]');
        this.imageEl = this.querySelector('[data-upsell-image]');
        this.errorEl = this.querySelector('[data-upsell-error]');

        this.select?.addEventListener('change', this.onVariantChange);
        this.form?.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        this.select?.removeEventListener('change', this.onVariantChange);
        this.form?.removeEventListener('submit', this.onSubmit);
        clearTimeout(this.resetTimer);
      }

      onVariantChange = (event) => {
        // Keep the change inside this block so it never triggers the main product's variant logic.
        event.stopPropagation();

        const option = this.select?.selectedOptions[0];
        if (!option) return;

        if (this.priceEl && option.dataset.price) {
          this.priceEl.textContent = option.dataset.price;
        }

        if (this.compareEl) {
          if (option.dataset.compare) {
            this.compareEl.textContent = option.dataset.compare;
            this.compareEl.hidden = false;
          } else {
            this.compareEl.hidden = true;
          }
        }

        if (this.imageEl && option.dataset.image) {
          this.imageEl.removeAttribute('srcset');
          this.imageEl.src = option.dataset.image;
        }

        const available = option.dataset.available === 'true';
        this.setButtonState(available ? 'ready' : 'soldout');
        this.hideError();
      };

      setButtonState(state) {
        if (!this.button) return;
        const labels = {
          ready: this.dataset.buttonText,
          soldout: this.dataset.soldOutText,
          added: this.dataset.addedText,
        };

        this.button.removeAttribute('aria-busy');

        if (state === 'loading') {
          this.button.disabled = true;
          this.button.setAttribute('aria-busy', 'true');
          return;
        }

        this.button.disabled = state === 'soldout';
        if (labels[state]) this.button.textContent = labels[state];
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || this.dataset.errorText || '';
        this.errorEl.hidden = false;
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }

      onSubmit = async (event) => {
        event.preventDefault();
        if (!this.button || this.button.disabled) return;

        const formData = new FormData(this.form);
        const variantId = Number(formData.get('id'));
        const quantity = Number(this.dataset.quantity) || 1;
        if (!variantId) return;

        this.hideError();
        this.setButtonState('loading');

        const root = window.Shopify?.routes?.root || '/';
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);

        const payload = { items: [{ id: variantId, quantity }] };
        if (sectionIds.length) payload.sections = sectionIds.join(',');

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          });
          const data = await response.json();

          if (!response.ok || data.status) {
            this.showError(data.description || data.message);
            this.setButtonState('ready');
            return;
          }

          let cart;
          try {
            cart = await (await fetch(`${root}cart.js`)).json();
          } catch (_) {
            cart = undefined;
          }

          // Same event the theme uses, so the cart drawer, cart page and cart bubble all update.
          const cartEvent = new Event('cart:update', { bubbles: true });
          cartEvent.detail = {
            resource: cart,
            sourceId: this.id,
            data: {
              source: 'upsell-product-block',
              itemCount: cart?.item_count ?? quantity,
              variantId: String(variantId),
              sections: data.sections,
            },
          };
          this.dispatchEvent(cartEvent);

          if (this.dataset.openDrawer === 'true') {
            document.querySelector('cart-drawer-component')?.open?.();
          }

          this.setButtonState('added');
          clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => this.setButtonState('ready'), 2000);
        } catch (error) {
          console.error(error);
          this.showError();
          this.setButtonState('ready');
        }
      };
    }

    customElements.define('upsell-product-block', UpsellProductBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
